import { isWhatuni } from "./utlils/commonFunction";

export const getPathNameScholarshipSearch = (
  provider: any,
  subject: any,
  level: any,
) => {
  return process.env.PROJECT === "Whatuni"
    ? provider
      ? subject
        ? `/csearch/${level}/${subject}/${provider}`
        : `/csearch/${level}/${provider}`
      : subject
        ? `/search/${level}/${subject}`
        : `/search/${level}`
    : provider
      ? subject
        ? `/csearch/${subject}/${provider}`
        : `/csearch/${provider}`
      : `/search/${subject}`;
};

export const SEO_DEFAULT_TITLE = "Default title";
export const SEO_DEFAULT_DESC = "Default Description";
export const ALTERNATE_NAME =
  "Compare the Best University Degrees Courses UK | Whatuni";
export const SITE_URL = "https://www.whatuni.com";
export const SITE_LOGO =
  "https://images.ctfassets.net/szez98lehkfm/UEsONfx1Q29FkoafrRlPT/48671d5a3805fd5d995404c244db1276/whatuni_logo.svg";
export const SITE_DESC =
  "Whatuni is the UK's biggest student reviews and university comparison site, helping prospective students compare courses, read honest reviews, and explore university rankings like the Whatuni Student Choice Awards.";
export const FOUNDING_DATE = "2003-07-22";
export const FACEBOOK_URL = "https://www.facebook.com/whatuni";
export const TWITTER_URL = "https://twitter.com/Whatuni";
export const INSTAGRAM_URL = "https://www.instagram.com/whatuni";
export const TIKTOK_URL = "https://www.tiktok.com/@whatuni";
export const UK = "UK";
export const LANGUAGE = "English";
export const CONSTACT_POINT = "ContactPoint";
export const FORM = "Form";
export const SCHOLARSHIP_PATH = isWhatuni()
  ? "/money/scholarships"
  : "/funding/scholarships";

export const PODS_PER_PAGE = {
  scholarshipPages: 6,
  searchResultPage: 10,
  providerResultPage: 9,
};

export const SCHOLARSHIP_PARAM_ORDER = [
  "nationality",
  "award-type",
  "award-coverage",
];
